import React from 'react';
import { PokemonContext } from "../context/pokemonContext";

const Profile = () => {

    const { pokemon } =React.useContext(PokemonContext);

    return (
        <div className="profile row">
                
            <div className="col-lg-6 col-md-12 col-sm-6">
                <div className="row">
                    <div className="col-6 text-end">Height : </div>
                    <div className="col-6">{pokemon.height} ft.</div>
                </div>
                <div className="row">
                    <div className="col-6 text-end">Weight : </div>
                    <div className="col-6">{pokemon.weight} lbs</div>
                </div>
                <div className="row">
                    <div className="col-6 text-end">Habitat : </div>
                    <div className="col-6">{pokemon.habitat}</div>
                </div>
            </div>

            <div className="col-lg-6 col-md-12 col-sm-6">
                <div className="row">
                    <div className="col-6 text-end">Growth Rate : </div>
                    <div className="col-6">{pokemon.growthRate}</div>
                </div>
                <div className="row">
                    <div className="col-6 text-end">Catch Rate : </div>
                    <div className="col-6">{pokemon.catchRate}%</div>
                </div>
                <div className="row">
                    <div className="col-6 text-end">Shape : </div>
                    <div className="col-6">{pokemon.shape}</div>
                </div> 
            </div>
        </div>
    );
}

export default Profile;